<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter_title"><a id="page_21"></a><a id="pg21lev1"></a>HOJA SANTA VINAIGRETTE</h2>
<p class="recipe_hdnote">This is one of my favorite dressings, based on the flavors of “Italian dressing”—olive oil and lots of garlic—but made with hoja santa, “or holy leaf.” Hoja santa is an herb with big, floppy leaves that tastes slightly of anise, tarragon, sassafras, and mint. At Bar Amá we use it in chile pastes, salsas, soups, and beans. I’ve also used it to wrap vegetables before roasting and added it to infusions for ice cream. Sometimes I toast it a little over an open flame to bring out the oils before adding it to a recipe. It’s definitely a favorite herb. We’re lucky to get it fresh here in Los Angeles; I grow a big pot of it at home.</p>
<p class="recipe_hdnote"><a id="pg21note1"></a><span class="yellow">NOTE:</span> Fresh hoja santa is available at Latino markets. You can substitute dried hoja santa, also available at Latino markets and online. One caveat: Dried hoja santa should have a pleasant, subtle anise flavor. If it doesn’t, it’s been on the shelf too long.</p>
<div class="wrap">
<p class="image"><a id="page_20"></a><img alt="image" class="vertical" src="images/f0020-01.jpg"/></p>
</div>
<p class="yield">MAKES ABOUT <sup>1</sup>/<sub>2</sub> CUP (120 ML)</p>
<p class="ingred_sublistt"><em>1 small fresh hoja santa leaf (or <sup>1</sup>/<sub>2</sub> large leaf ), or 1 tsp dried hoja santa</em></p>
<p class="ingred_sublist"><em>1 garlic clove, grated with a rasp-style grater</em></p>
<p class="ingred_sublist"><em>2 Tbsp fresh yuzu juice, or juice of 1 lime</em></p>
<p class="ingred_sublist"><em><sup>1</sup>/<sub>4</sub> tsp fresh black pepper</em></p>
<p class="ingred_sublist"><em>Pinch of fine sea salt</em></p>
<p class="ingred_sublist"><em><sup>1</sup>/<sub>3</sub> cup [80 ml] extra-virgin olive oil</em></p>
<p class="method_txt">Pass the fresh hoja santa leaf back and forth over the open flame of a gas burner so that it gets toasty and releases its oils, about 20 seconds. (You can use tongs for this.)</p>
<p class="method_txt1">Finely chop the hoja santa and put it into a small jar with a lid. Add the garlic, yuzu juice, black pepper, and sea salt. Seal the jar, and shake to combine. Add the olive oil, reseal, and shake. Use immediately or store, covered, in the refrigerator for up to 1 week.</p>
<div class="sidebar">
<p class="sidebar1_hd">OREGANO VINAIGRETTE</p>
<p class="sidebar1_hdnote">Substitute 2 heaping tsp of dried Mexican oregano, preferably Oregano Indio <a href="#/xhtml/09chapter02#pg17note1">(see Note, page 17)</a>, for the hoja santa.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11-chapter04.vue?2d1a9570